import { render, staticRenderFns } from "./returnpurchasewarehouseout.vue?vue&type=template&id=5a90b994&scoped=true&"
import script from "./returnpurchasewarehouseout.vue?vue&type=script&lang=js&"
export * from "./returnpurchasewarehouseout.vue?vue&type=script&lang=js&"
import style0 from "./returnpurchasewarehouseout.vue?vue&type=style&index=0&id=5a90b994&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a90b994",
  null
  
)

export default component.exports